import SmallBadge from '@/common/components/SmallBadge'
import { cn } from '@/common/utils/cn'
import { formatPercentage } from '@/common/utils/formatters'
import { LucideIcon } from 'lucide-react'

interface ProposalAwareResumeItemProps {
  label: string
  Icon?: LucideIcon
  originalValue: number
  newValue: number | null | undefined
  differencePercentage?: string | null
  format: (value: number) => string
  higherIsBetter?: boolean
  className?: string
}

const ProposalAwareResumeItem = ({
  Icon,
  originalValue,
  newValue,
  differencePercentage,
  format,
  higherIsBetter = false,
  className,
}: ProposalAwareResumeItemProps) => {
  const hasModification = newValue !== null && newValue !== undefined

  if (!hasModification) {
    return (
      <SmallBadge
        LeftIcon={Icon}
        text={format(originalValue)}
        className={className}
      />
    )
  }

  const increasedClass = higherIsBetter ? 'text-success-tertiary' : 'text-danger-soft'
  const decreasedClass = higherIsBetter ? 'text-danger-soft' : 'text-success-tertiary'

  const newValueClassName = newValue > originalValue ? increasedClass : newValue < originalValue ? decreasedClass : ''

  const differencePercentageNumber = differencePercentage != null ? Number(differencePercentage) : null

  const showDifferencePercentage = differencePercentageNumber != null && differencePercentageNumber !== 0

  return (
    <SmallBadge
      LeftIcon={Icon}
      className={className}
    >
      <span className="flex items-center gap-1">
        <span className={newValueClassName}>
          {format(newValue)}
        </span>

        <span className="text-xs text-white-400 line-through italic font-light">
          {format(originalValue)}
        </span>

        {showDifferencePercentage && (
          <span className={cn(
            'text-[11px] text-white-800 inline-flex items-center',
            newValueClassName
          )}>
            {differencePercentageNumber > 0 ? '+' : '-'}
            {formatPercentage(Math.abs(differencePercentageNumber))}
          </span>
        )}
      </span>
    </SmallBadge>
  )
}

export default ProposalAwareResumeItem
